import React, { Suspense, useState } from 'react';
import { useGlobalContext } from 'GlobalState/Context/GlobalContext';

// Table
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import TableEmployees from 'components/Tables/Mangage/TableEmployees/TableEmployees';
import SearchFilter from 'components/Tables/SearchField';
import SkeletonTable from 'components/LoadingSkeletons/SkeletonTable/SkeletonTable';
import ExternalStateCheckbox from 'components/Checkbox/ExternalStateCheckbox';

// Form
import EmployeesForm from 'components/Form/Manage/ManageEmployeesForm/EmployeesForm';

// UI components
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Card from 'components/Card/Card';
import Button from 'components/Button/Button';

const EmployeesSubtab = () => {
  const { globalDispatch } = useGlobalContext();
  const [shouldShowInactive, setShouldShowInactive] = useState(false);

  const handleAddPopup = () => {
    globalDispatch({
      type: 'setModalContent',
      payload: (
        <ErrorBoundary>
          <Suspense fallback={<div>Loading</div>}>
            <EmployeesForm heading="Create Employee" type="create" />
          </Suspense>
        </ErrorBoundary>
      ),
    });
  };
  return (
    <>
      <Card
        title="Employees"
        leftAdditional={
          <label>
            Show Inactive
            <ExternalStateCheckbox
              setIsChecked={setShouldShowInactive}
              isChecked={shouldShowInactive}
            />
          </label>
        }
        headerAdditional={
          <FlexContainer spaceX="children-x-10px">
            <SearchFilter />
            <Button
              clicked={handleAddPopup}
              text="Add"
              type="button-primary"
              additionalInlineStyles={{
                minWidth: '6.25em',
                paddingTop: '0.375em',
                paddingBottom: '0.375em',
              }}
            />
          </FlexContainer>
        }
      >
        <ErrorBoundary>
          <Suspense fallback={<SkeletonTable countTableBodyRows={50} />}>
            <TableEmployees shouldShowInactive={shouldShowInactive} />
          </Suspense>
        </ErrorBoundary>
      </Card>
    </>
  );
};

export default EmployeesSubtab;
